module.exports = __webpack_public_path__ + "static/media/my_green_company.c0645eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my_green_company.png
// module id = 1851
// module chunks = 0